import React from 'react';
import ComponentErp from './ComponentErp.js';
import store from '../store';

import FormEdit from '../components/FormEdit.js';
import { GetRelatorioContasAPI } from '../models/ModelContasPagar.js';


class RelatorioContasPagarContas extends ComponentErp {
  constructor(props) {
    super(props);
    this.state = store.getState().relContasPagarGeral.gridsContas;    
  }

  componentDidMount() {
    this.callApi()
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.state.refresh === 'gravando') {
      this.setState({ refresh: 'buscando' });
      this.callApi()
    }

  }

  handleSubmit = (event) => {
    event.preventDefault()
    var response = {
      refresh: 'gravando',
      fAno: this.state.fAno,
      type: 'RELCONTASPAGARCONTAS.TOOGLE_FBUSCA'
    }
    this.updateReduxAndState(response);

  }

  async callApi() {
    var gridsContas = store.getState().relContasPagarGeral.gridsContas;

    var response = await GetRelatorioContasAPI(gridsContas.fAno);
    response.refresh = 'concluido';
    response.type = 'RELCONTASPAGARCONTAS.TOOGLE_LISTA';

    this.updateRedux(response);
    gridsContas = store.getState().relContasPagarGeral.gridsContas;
    this.setState(gridsContas);
  }



  render() {

    return (

      <div className="container">
        <div className="row">
          <h2 className="section-title">Relatório - Despesa por conta</h2>
          <div className="card">
            {this.navMenu(store.getState().relContasPagarGeral.gridsContas.nav)}

            <div id="lista" className="dataTables_wrapper no-footer row">
              <form name="form" onSubmit={this.handleSubmit} action="" method="get" encType="multipart/form-data">

                {<FormEdit id='fAno'
                  label='Ano'
                  value={this.state.fAno}
                  onChange={this.handleInputChange}
                  typeField='number'
                  styleDiv='4' />}

                {<FormEdit id='submit'
                  label='Pesquisar'
                  styleDiv='submit'
                  styleField='submit'
                  typeField='submit'
                  icon='pesquisa'
                />}

              </form>

              {this.GridFull(store.getState().relContasPagarGeral.gridsContas)}
            </div>

          </div>
        </div>
      </div>

    );

  }
}
export default (RelatorioContasPagarContas);
